
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"5.33 5.33 21.33 21.33"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"5.833","y":"7.167","width":"20.333","height":"19","rx":"1.5","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M6.667 18.667h3.011a.5.5 0 00.455-.293l2.608-5.736a.5.5 0 01.94.085l2.533 10.132c.124.497.825.508.966.016l1.837-6.43a.5.5 0 01.91-.12l1.26 2.103a.5.5 0 00.43.243h3.716","stroke":"currentColor","fill":"unset !important"}}),_c('rect',{attrs:{"x":"10.667","y":"5.333","width":"1.333","height":"4","rx":".667","fill":"currentColor"}}),_c('rect',{attrs:{"x":"20","y":"5.333","width":"1.333","height":"4","rx":".667","fill":"currentColor"}})])
          )
        }
      }
    